import { createSelector } from 'reselect';
import { RootState } from 'types';
import { EntityTypes } from 'constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { IActionBasic } from 'types/domain/action';
import { parseAction } from './action';
import { IActionFeed, IActionFeedItem, selectActionFeed } from './actionFeed';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?: number) => id || state.state[EntityTypes.ACTION];
const feed = selectActionFeed;

const getActionConfigEnd = (action: IActionBasic) => {
  const config = action?.voiceSceneConfigId ? action.voiceSceneConfig : action.sceneConfig;
  return config?.end;
};

const getActionConfigStart = (action: IActionBasic) => {
  const config = action?.voiceSceneConfigId ? action.voiceSceneConfig : action.sceneConfig;
  return config?.start;
};

const getActionSceneId = (action: IActionBasic) => action?.voiceSceneId ?? action?.sceneId;

export const selectActionEndTime = createSelector(
  [entity, id, feed],
  (entity: IEntityReducer, id: number, feed: IActionFeed) => {
    const action = parseAction(entity, id);

    if (!action) return null;

    const actionEnd = getActionConfigEnd(action);
    if (actionEnd == null) return null;

    const currentIndex = feed.feed.findIndex((item: IActionFeedItem) => item.actionId === id);
    if (currentIndex === -1) return actionEnd;

    const nextActionId = feed.feed[currentIndex + 1]?.actionId;
    if (!nextActionId) return actionEnd;

    const nextAction = parseAction(entity, nextActionId);
    if (!nextAction) return actionEnd;

    const hasSameScene = getActionSceneId(action) === getActionSceneId(nextAction);
    if (!hasSameScene) return actionEnd;

    const nextActionStart = getActionConfigStart(nextAction);

    return nextActionStart != null && nextActionStart < actionEnd ? nextActionStart : actionEnd;
  },
);
